module.exports = __webpack_public_path__ + "static/media/02290016-9zB0wSgs.207aa95c.JPG";